import { ReactNode } from 'react';
import classNames from 'classnames';

import { StatementPeriodType } from '../../lib/models/fundamental/types';

import {
  FinancialPeriodButtons,
  GoBackButton,
  Grid,
  Preloader,
} from '../../components';
import SimpleFinancialTableRow from '../../components/SimpleFinancialTableRow/SimpleFinancialTableRow';
import TimeOptionsModal from '../SymbolDetails/Tabs/Ratios/Modals/TimeOptionsModal';

import styles from './SymbolDetailsFinancialsInternalScreen.module.scss';

type Props = {
  title: string;

  preloaderOwner: string;

  loading: boolean;
  isMobile: boolean;

  period: StatementPeriodType;
  onPeriodChange: (period: StatementPeriodType) => void;

  headers: string[];
  timeOptions: string[];
  selectedPeriodIndex: number;
  onPeriodIndexChange: (index: number) => void;

  mobileRows: ReactNode;
  desktopRows: ReactNode;
};

const FinancialStatementLayout = ({
  title,
  preloaderOwner,
  loading,
  isMobile,
  period,
  onPeriodChange,
  headers,
  timeOptions,
  selectedPeriodIndex,
  onPeriodIndexChange,
  mobileRows,
  desktopRows,
}: Props) => {
  if (loading) {
    return (
      <div className={styles.loader}>
        <Preloader isFullScreen text="" owner={preloaderOwner} />
      </div>
    );
  }

  return (
    <Grid>
      <div className={styles.wrapper}>
        {!isMobile && (
          <div className={styles.backButton}>
            <GoBackButton />
          </div>
        )}

        <div className={styles.header}>
          <div className={styles.title}>
            {title}
          </div>
        </div>
        <div className={styles.periodButtonsWrapper}>
          <FinancialPeriodButtons currentPeriod={period} setPeriod={onPeriodChange} />
        </div>
        <div className={classNames(styles.tableWrapper, { [styles.tableWrapperMob]: isMobile })}>
          {isMobile ? (
            <>
              <div className={styles.periodButtons}>
                <TimeOptionsModal
                  options={timeOptions}
                  currentOption={timeOptions[selectedPeriodIndex]}
                  onTimeChange={onPeriodIndexChange}
                  isDisabled={false}
                  currentPeriod={period}
                />
              </div>
              <SimpleFinancialTableRow
                type="Type"
                value={timeOptions[selectedPeriodIndex] || 'N/A'}
              />
              <div className={styles.wrapperInfo}>
                {mobileRows}
              </div>
            </>
          ) : (
            <div className={styles.table2}>
              <div className={styles.tableHeadBody}>
                {headers.map((header) => (
                  <div className={styles.tableHead} key={header}>{header}</div>
                ))}
              </div>
              {desktopRows}
            </div>
          )}
        </div>
      </div>
    </Grid>
  );
};

export default FinancialStatementLayout;
